import { render, staticRenderFns } from "./recommendDialog.vue?vue&type=template&id=80f576bc&scoped=true&"
import script from "./recommendDialog.vue?vue&type=script&lang=js&"
export * from "./recommendDialog.vue?vue&type=script&lang=js&"
import style0 from "./recommendDialog.vue?vue&type=style&index=0&id=80f576bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f576bc",
  null
  
)

export default component.exports